import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { LinkObject, TSpsSeo, PageMetas, MainNav, Footer } from '@models/interfaces';
import { TLanguage } from '@core/config';

export namespace PageMetasActions {
  export const clear = createAction('[PAGE METAS] clear');
  export const buildMetas = createAction('[PAGE METAS] buildMetas', props<{ payload: TSpsSeo }>());
  export const setMetas = createAction('[PAGE METAS] setMetas', props<{ payload: PageMetas; merge?: boolean }>());
  export const setTitle = createAction('[PAGE METAS] setTitle', props<{ title: string }>());

  export const setLanguage = createAction('[PAGE_METAS] setLanguage', props<{ language: TLanguage; fetchNav?: boolean }>());

  export const setCanonicalUrl = createAction('[PAGE METAS] setCanonicalUrl', props<{ path: string }>());

  export const fetchMainNavItems = createAction('[PAGE METAS] fetchMainNavItems');

  export const fetchMainNavItemsSuccess = createAction(
    '[PAGE METAS] fetchMainNavItemsSuccess',
    props<{ payload: MainNav.LanguageConfig }>()
  );
  export const fetchMainNavItemsError = createAction(
    '[PAGE METAS] fetchMainNavItemsError',
    props<{ error: HttpErrorResponse }>()
  );

  export const fetchFooterNavItems = createAction('[PAGE METAS] fetchFooterNavItems');

  export const fetchFooterNavItemsSuccess = createAction(
    '[PAGE METAS] fetchFooterNavItemsSuccess',
    props<{ payload: Footer.LanguageConfig }>()
  );

  export const fetchFooterNavItemsError = createAction(
    '[PAGE METAS] fetchFooterNavItemsError',
    props<{ error: HttpErrorResponse }>()
  );

  export const updateWidgetSettings = createAction(
    '[PAGE_METAS] updateWidgetSettings',
    props<{ enabled: boolean; link?: LinkObject }>()
  );

  export const setLoading = createAction('[PAGE_METAS] setLoading', props<{ loading: boolean }>());
}
